import React, { useEffect, useState } from "react";
import "./development.css";

import UnderDevelopment from "./assets/images/under_development.svg";
import VersionControl from "./assets/images/version_control.svg";

function DevelopmentPage() {
  const illustrations = [UnderDevelopment, VersionControl];

  const [currentIllustration, setCurrentIllustration] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 0 : prev + 1));
    }, 60);

    const imageInterval = setInterval(() => {
      setCurrentIllustration((prev) => (prev + 1) % illustrations.length);
    }, 5000);

    return () => {
      clearInterval(progressInterval);
      clearInterval(imageInterval);
    };
  }, []);

  return (
    <div className="development-page">
      <div className="development-card">

        <div className="left">

          <img
            className="logo"
            src="https://res.cloudinary.com/harshdubey1198/image/upload/v1784273049/logo-light-full_zwtwvd.png"
            alt="RS CRM"
          />

          <span className="tag">APP / CRM</span>

          <h1>
            RS-CRM is
            <br />
            Under Development
          </h1>

          <p>
            We're building the next generation of <strong>RS-CRM</strong> with
            enhanced performance, scalability and a significantly better user
            experience.
            <br />
            <br />
            This environment is reserved for QA and testing purposes.
            You can continue using the Development Environment while we finish
            the production release.
          </p>

          <div className="url-box">
            <div className="url-title">
              Development Environment
            </div>

            <div className="url">
              https://dev.realtyshopee.in
            </div>
          </div>

          <div className="btn-area">

            <a
              href="https://dev.realtyshopee.in"
              className="primary-btn"
            >
              Open Development Environment →
            </a>

            <a
              href="mailto:freelancer.harsh1198@gmail.com"
              className="secondary-btn"
            >
              Contact Development Team
            </a>

          </div>

          <div className="progress-wrapper">

            <div className="progress-head">
              <span>Redirecting...</span>
              <span>{Math.round(progress)}%</span>
            </div>

            <div className="progress">
              <div
                className="progress-bar"
                style={{
                  width: `${progress}%`,
                }}
              />
            </div>

          </div>

          <div className="note">
            Have a <strong>development query?</strong> Please contact the
            Development Team or continue to the testing environment using the
            button above.
          </div>

        </div>

        <div className="right">

          <img
            className="illustration"
            src={illustrations[currentIllustration]}
            alt="Development Illustration"
          />

        </div>

      </div>
    </div>
      );
}

export default DevelopmentPage;